import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { LinkModel } from '@flocasts/experience-service-types'
import { distinctUntilChanged } from 'rxjs/operators'
@Injectable({ providedIn: 'root' })
export class DecoratedTextCellCommunicationService {
  private decoratedTextCellLinkClickSubject = new Subject<LinkModel | undefined>()

  decoratedTextCellLinkClick$ = this.decoratedTextCellLinkClickSubject.pipe(
    distinctUntilChanged((a: LinkModel, b: LinkModel) => a.apiCall === b.apiCall)
  )

  public emitDecoratedTextCellLinkClick(event: LinkModel) {
    this.decoratedTextCellLinkClickSubject.next(event)
  }

  public clearValue() {
    this.decoratedTextCellLinkClickSubject.next(undefined)
  }
}
